(ns rothko.theme.manatee.link
  (:require [garden.color :refer [darken]]
            [rothko.theme.manatee.colours :refer [colours]]))

(def link
  {:default
   {:color (:blue-light colours)
    :color--hover (darken (:blue-light colours) 15)}})
